import useAdminStore from "../stores/useAdminStore";

const useAdmin = (isAdmin) => {
  const setIsAdmin = useAdminStore((state) => state.setIsAdmin);
  setIsAdmin(isAdmin);
};

export default useAdmin;
